"use client";

import { ArrowUpRight, Calendar, Gift, Utensils } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheDayOfCelebration() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const pillars = [{
    reference: "§ 01 / THE GATHERING",
    title: "Event Details & Venue",
    description: "Join us for an intimate brunch celebration at The Glass House. A morning dedicated to new beginnings, shared stories, and the joy of family.",
    subServices: ["OCTOBER 12TH, 2026", "11:00 AM — 2:00 PM", "The Glass House, Portland"],
    Icon: Calendar
  }, {
    reference: "§ 02 / THE MENU",
    title: "Seasonal Brunch Fare",
    description: "A curated selection of organic, locally-sourced delights. From botanical-infused mocktails to artisanal pastries, every bite is a celebration.",
    subServices: ["Avocado & Heirloom Toast", "Wildberry Parfaits", "Botanical Tea Service"],
    Icon: Utensils
  }, {
    reference: "§ 03 / THE REGISTRY",
    title: "Curated Gift Registry",
    description: "Your presence is the greatest gift. Should you wish to contribute to our nursery, we have curated a list of essentials for Baby Ohlson's arrival.",
    subServices: ["Organic Cotton Linens", "Sustainable Wooden Toys", "Nursery Essentials"],
    Icon: Gift
  }];
  return <section data-section-id="2803" id="the-day-of-celebration" className="bg-background text-foreground py-24 md:py-36 px-6 md:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`text-center mb-20 md:mb-28 transition-all duration-1000 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-xs md:text-sm tracking-[0.2em] uppercase text-muted-foreground mb-8">
            § 05 — THE CELEBRATION
          </p>
          <h2 className="font-default font-normal text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight max-w-4xl mx-auto">
            The day of
            <br />
            our{" "}
            <em className="font-serif italic font-normal" style={{
            color: "var(--primary)"
          }}>
              joy
            </em>
            .
          </h2>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 relative transition-all duration-1000 delay-200 ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {pillars.map((pillar, i) => {
          const Icon = pillar.Icon;
          return <div data-index={i} key={pillar.reference} className={`group relative px-6 md:px-10 py-12 md:py-8 transition-all duration-500 ${i > 0 ? "md:border-l border-t md:border-t-0 border-border" : ""}`}>
                {}
                <div className="hidden md:block absolute top-0 bottom-0 left-0 w-px opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" style={{
              background: "linear-gradient(to bottom, transparent 0%, var(--primary) 50%, transparent 100%)"
            }} aria-hidden="true" />
                <div className="hidden md:block absolute top-0 bottom-0 right-0 w-px opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" style={{
              background: "linear-gradient(to bottom, transparent 0%, var(--primary) 50%, transparent 100%)"
            }} aria-hidden="true" />

                {}
                <div className="mb-10 flex items-start">
                  <Icon className="w-24 h-24 transition-colors duration-500" strokeWidth={1.25} style={{
                color: "var(--primary)"
              }} aria-hidden="true" />
                </div>

                {}
                <p className="font-mono text-xs tracking-[0.2em] uppercase text-muted-foreground mb-5">
                  {pillar.reference}
                </p>

                {}
                <h3 className="font-default font-semibold text-2xl md:text-3xl leading-tight mb-6 text-foreground">
                  {pillar.title}
                </h3>

                {}
                <p className="font-default text-sm md:text-[15px] leading-relaxed text-muted-foreground mb-8">
                  {pillar.description}
                </p>

                {}
                <ul className="space-y-3 mb-10">
                  {pillar.subServices.map((service, j) => <li data-index={j} key={service} className="flex items-center gap-3 font-mono text-[11px] tracking-[0.15em] uppercase text-foreground/80">
                      <span className="w-1 h-1 rounded-lg shrink-0" style={{
                  backgroundColor: "var(--primary)"
                }} aria-hidden="true" />
                      <span>{service}</span>
                    </li>)}
                </ul>

                {}
                <Link to="/EventDetailsPage" className="inline-flex items-center gap-2 font-mono text-xs tracking-[0.2em] uppercase text-foreground/70 hover:text-foreground transition-colors duration-300 group/link">
                  <span className="relative">
                    VIEW DETAILS
                    <span className="absolute left-0 -bottom-1 h-px w-8 group-hover/link:w-full transition-all duration-500 ease-out" style={{
                  backgroundColor: "var(--primary)"
                }} aria-hidden="true" />
                  </span>
                  <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5" strokeWidth={1.5} />
                </Link>
              </div>;
        })}
        </div>
      </div>
    </section>;
}